import api from '@/api/ticket';

export default {
  state: {
    makeTicketData: null,
    tickets: null,
    ticket: null,
    files: [],
    ticketResponse: null,
    cancelReasons: null,
    cancelResponse: null,
    answerResponse: null,
    evaluationResponse: null,
    allTicketStatus: null,
    ticketsTotalQtt: null,
    selectedAddress: {},
    appeal: null,
    protocol: null,
    ticketsByProtocol: null
  },

  getters: {
    postTicketData: (state) => state.makeTicketData,
    getTickets: (state) => state.tickets,
    getTicket: (state) => state.ticket,
    getTicketResponse: (state) => state.ticketResponse,
    getCancelReasons: (state) => state.cancelReasons,
    getCancelResponse: (state) => state.cancelResponse,
    getAnswerResponse: (state) => state.answerResponse,
    getTicketFiles: (state) => state.files,
    getSelectedAddress: (state) => state.selectedAddress,
    getAllStatus: (state) => state.allTicketStatus,
    ticketsTotalQtt: (state) => state.ticketsTotalQtt,
    getAppeal: (state) => state.appeal,
    getTicketsByProtocol: (state) => state.ticketsByProtocol
  },

  actions: {
    async postTicket({ commit } , ticket ){
      try{

        var formData = new FormData();

        if(ticket.address?.street){
          let addressArray = Object.entries(ticket.address);

          addressArray.forEach(element => {
            if (element[1] !== null && element[1] !== undefined) {
              formData.append(`address[${element[0]}]`, element[1]);
            }
          });
        }

        formData.append('description', ticket.description);
        formData.append('origin', 'web');
        formData.append('subject_id', ticket.subject_id);
        formData.append('anonymous', ticket.anonymous);
        formData.append('is_confidential', ticket.confidential);

        if(ticket.previous_protocol)
          formData.append('previous_protocol', ticket.previous_protocol);

        if(ticket.manifestation)
          formData.append('manifestation', ticket.manifestation);

        if (ticket.issuerCompany.name || ticket.issuerCompany.cnpj) {
          formData.append('issuer_company', ticket.issuerCompany.name);
          formData.append('issuer_cnpj', ticket.issuerCompany.cnpj.replace(/\D/g, ''));
        }

        if(ticket.department)
          formData.append('department_id', ticket.department.id);

        ticket.files.forEach(function (element, index) {
          formData.append(`file[${index}]`, element);
        });

        if(ticket.otherAddress?.street){
          formData.append(`subject_custom_field_answer[${ticket.otherAddress.id}].address`,
            JSON.stringify(ticket.otherAddress));
        }

        if(ticket.choiceField.answer) {
          formData.append(`subject_custom_field_answer[${ticket.choiceField.id}]`, ticket.choiceField.answer);
        }

        if(ticket.textField.answer) {
          formData.append(`subject_custom_field_answer[${ticket.textField.id}]`, ticket.textField.answer);
        }

        const response = await api.createTicket(formData);

        commit('SET_TICKET_RESPONSE', response.data.data);
        commit('RESET_TICKET_DATA');
        commit('RESET_TICKET_FILES');

        return Promise.resolve(response.data.data);

      }
      catch (error){
        return Promise.reject(error.response);
      }
    },

    resetTicket({ commit }) {
      commit('RESET_TICKET_DATA');
      commit('RESET_USER_ADDRESS');
    },

    /**
     * Asynchronously fetches ticket data based on provided filters and commits the result.
     *
     * @example
     * // Example 1: With single values
     * getTicketsData({ commit }, { status_id: "r8h-42j-sdf", category: "technology" });
     * // Resulting query string: "?status_id=r8h-42j-sdf&category=technology"
     *
     * @example
     * // Example 2: With multiple values for the same key
     * getTicketsData({ commit }, { status_id: ["r8h-42j-sdf", "ut7-3pf-9h5"], code: "53452" });
     * // Resulting query string: "?status_id=r8h-42j-sdf&status_id=ut7-3pf-9h5&code=53452"
     */
    async getTicketsData({ commit }, filters = null){
      let queryString = '';

      if (filters) {
        const filtersList = filters;
        let queryParams = [];

        // Iterate over each key in the filters object
        for (const key in filtersList) {
          if (Object.prototype.hasOwnProperty.call(filters, key)) {
            const value = filters[key];

            if (Array.isArray(value)) {
              // If the value is an array, create multiple query parameters for each item
              value.forEach((v) => {
                queryParams.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`);
              });
            } else {
              // If the value is not an array, create a single query parameter
              queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
          }
        }
        // Join all query parameters with '&' and prepend '?' to form the query string
        queryString = `?${queryParams.join('&')}`;
      }

      try{
        const response = await api.getTickets(queryString);

        commit('SET_TICKETS', response.data.data);
        commit('TICKETS_TOTAL_QTT', response.data?.meta?.total);
      }
      catch (error){
        commit('SET_TICKETS', null);

        return error.response;
      }
    },

    async getTicketData({ commit } , ticketId ){

      try{
        const response = await api.getTicket(ticketId);

        commit('SET_TICKET', response.data.data);

        return Promise.resolve(response.data.data);

      }
      catch (error){
        commit('SET_TICKET', null);

        return Promise.reject(error.response);
      }
    },

    async getWhatsappTicket({ commit }, wppCode) {
      try {
        const response = await api.getWppTicket(wppCode);

        commit('SET_TICKET', response.data.data);

        return Promise.resolve(response.data.data);

      } catch (error) {
        commit('SET_TICKET', null);

        return Promise.reject(error.response);
      }
    },

    saveTicketFiles({ commit }, files) {
      commit('SET_TICKET_FILES', files[0]);
    },

    resetTicketFiles({ commit }) {
      commit('RESET_TICKET_FILES');
    },

    async getReasons({ commit }){
      try {
        const response = await api.getReason();

        commit('SET_REASONS', response.data.data);

        return Promise.resolve(response.data.data);

      }
      catch (error) {
        commit('SET_REASONS', null);

        return Promise.reject(error.response);
      }
    },

    async cancelRegisteredTicket({ commit }, cancelInfo){
      try{
        const response = await api.cancelTicket(cancelInfo.ticketId, cancelInfo.motive);

        commit('SET_CANCEL_RESPONSE', `O protocolo N° ${cancelInfo.ticketProtocol} foi cancelado.`);

        return Promise.resolve(response.data.data);

      }
      catch (error){
        commit('SET_CANCEL_RESPONSE', error.response.data);

        return Promise.reject(error.response);
      }
    },

    async removeCancelRegisteredTicket({ commit }){
      commit('SET_CANCEL_RESPONSE', null);
    },

    async addTicketAnswer({ commit }, answerInfo) {
      try {
        var formData = new FormData();

        if(answerInfo.answer.file.length > 0) {
          answerInfo.answer.file.forEach(function (element, index) {
            formData.append(`file[${index}]`, element);
          });
        }

        if (answerInfo.answer.comment) formData.append('response', answerInfo.answer.comment);

        const response = await api.addAnswer(answerInfo.ticketId, formData);

        commit('SET_ANSWER_RESPONSE', response.data.data);

        return Promise.resolve(response.data.data);

      }
      catch (error) {
        return Promise.reject(error);
      }
    },

    async getAnonymousTicket({ commit }, protocolNumber) {
      try {
        const response = await api.anonymousTicket(protocolNumber);

        commit('SET_TICKET', response.data.data);

        return Promise.resolve(response.data.data);

      } catch (error) {
        commit('SET_TICKET', null);

        return Promise.reject(error.response);
      }
    },

    setTicket({ commit }, ticketData ){
      commit('SET_MAKE_TICKET_DATA', ticketData);
    },

    async evaluateTicket({ commit }, evaluationInfo) {
      try {
        const response = await api.evaluateTicket(evaluationInfo);

        commit('SET_EVALUATION_RESPONSE', null);

        return Promise.resolve(response.data);

      } catch (error) {
        commit('SET_EVALUATION_RESPONSE', null);

        return Promise.reject(error.response);
      }
    },

    saveSelectedAddress({ commit }, address) {
      commit('SET_USER_ADDRESS', address);
    },

    async getAllTicketStatus({ commit }) {
      try {
        const response = await api.getAllStatus();

        commit('SET_STATUS', response.data.data);

        return Promise.resolve(response.data.data);

      } catch (error) {
        commit('SET_STATUS', null);

        return Promise.reject(error.response);
      }
    },

    setAppealInfo({ commit }, appeal) {
      commit('SET_APPEAL', appeal);
    },

    async createAppeal({ commit }, appeal) {
      let formData = new FormData();

      formData.append('resource_description', appeal.description);

      try {
        const response = await api.postAppeal(appeal.id, formData);

        commit('SET_TICKET_RESPONSE', response.data.data);

        return Promise.resolve(response.data.data);
      } catch (error) {
        return Promise.reject(error.response);
      }
    },

    async searchTicketsByProtocol({ commit, state }, code) {
      if (code !== state.protocol) {
        try {
          commit('SET_PROTOCOL', code);

          const response = await api.searchTickets(code);

          commit('SET_TICKETS_BY_PROTOCOL', response.data.data);
        } catch (error) {
          return Promise.reject(error.response);
        }
      }
    }
  },

  mutations: {
    SET_TICKET_RESPONSE(state, payload){
      state.ticketResponse = payload;
    },
    SET_TICKETS(state, payload){
      state.tickets = payload;
    },

    SET_TICKET(state, payload){
      state.ticket = payload;
    },

    SET_TICKET_FILES(state, payload){
      state.files = payload;
    },

    RESET_TICKET_FILES(state) {
      state.files = [];
    },

    SET_MAKE_TICKET_DATA(state, payload){
      state.makeTicketData = payload;
    },

    RESET_TICKET_DATA(state){
      state.makeTicketData = null;
    },

    SET_REASONS(state, payload) {
      state.cancelReasons = payload;
    },

    SET_CANCEL_RESPONSE(state, payload) {
      state.cancelResponse = payload;
    },

    SET_ANSWER_RESPONSE(state, payload) {
      state.answerResponse = payload;
    },

    SET_EVALUATION_RESPONSE(state, payload) {
      state.evaluationResponse = payload;
    },

    SET_USER_ADDRESS(state, payload) {
      const addressId = Object.keys(payload)[0];

      state.selectedAddress[addressId] = payload[addressId];
    },

    RESET_USER_ADDRESS(state) {
      state.selectedAddress = {};
    },

    SET_STATUS(state, payload) {
      state.allTicketStatus = payload;
    },

    TICKETS_TOTAL_QTT(state, payload) {
      state.ticketsTotalQtt = payload;
    },

    SET_APPEAL(state, payload) {
      state.appeal = payload;
    },

    SET_PROTOCOL(state, payload) {
      state.protocol = payload;
    },

    SET_TICKETS_BY_PROTOCOL(state, payload) {
      state.ticketsByProtocol = payload;
    }
  }
};
